// all the available layers
// also defines z index of the layers
export enum Layers {
  BACKGROUND,
  STICKER,
  LOGO,
  TEXT,
  TRANSFORMER
}

export const allLayers = [Layers.BACKGROUND, Layers.LOGO, Layers.STICKER, Layers.TEXT]